import { memo } from 'react';
import { Scale, X, ChevronRight } from 'lucide-react';
import { useCompare } from '../contexts/CompareContext';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../config/translations';

const CompareBar = memo(function CompareBar() {
  const { count, openDrawer, clearCompare, maxProducts } = useCompare();
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  if (count === 0) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 animate-fade-in" aria-live="polite" aria-atomic="true">
      <div className="bg-primary-600 text-white rounded-full shadow-lg flex items-center gap-3 pl-4 pr-2 py-2">
        <Scale className="w-5 h-5" aria-hidden="true" />
        <span className="text-sm font-medium">
          {t('productsSelectedForCompare', { count, max: maxProducts })}
        </span>
        <button
          onClick={openDrawer}
          className="flex items-center gap-1 px-3 py-1.5 bg-white text-primary-600 rounded-full text-sm font-medium hover:bg-primary-50 transition-colors"
          aria-label={t('compare')}
        >
          {t('compare')}
          <ChevronRight className="w-4 h-4" aria-hidden="true" />
        </button>
        <button
          onClick={clearCompare}
          className="p-1.5 hover:bg-primary-700 rounded-full transition-colors"
          aria-label={t('clearAll')}
        >
          <X className="w-4 h-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
});

export default CompareBar;
